module.exports = __webpack_public_path__ + "img/1.b8f7636a.png";